module.exports = "pegasus_template/assets/blocks/image-3-theme3.png";